import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { color } from "@steiner/XDL/Utilities";
import React, { FC } from "react";
import { Cell, LabelList, Pie, PieChart, ResponsiveContainer } from "recharts";
import { css } from "styled-components";

interface Props {
    data: { name: string; value: string; displayValue: string; color: string }[];
}

interface DisplayPieChartStyles {
    container?: InjectableCss;
    infoContainer?: InjectableCss;
    infoTextContainer?: InjectableCss;
}

export const displayPieChartStyles: DisplayPieChartStyles = {};

const styles = displayPieChartStyles;
const DisplayPieChart: FC<Props> = ({ data }) => {
    return (
        <StyledWrapper {...styles.container} data-test-selector="DisplayPieChart">
            <ResponsiveContainer width={140} height={140}>
                <PieChart>
                    <Pie data={data} cx="50%" cy="50%" outerRadius={50} paddingAngle={0} dataKey="value">
                        {data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Pie>
                </PieChart>
            </ResponsiveContainer>
            <StyledWrapper {...styles.infoContainer}>
                {data.map(item => (
                    <StyledWrapper key={item.name} {...styles.infoTextContainer} {...{ itemColor: item.color }}>
                        <Typography weight="bold" size={12}>
                            {item.name}
                        </Typography>
                        <Typography size={12} weight="bold" color={item.color}>
                            {item.displayValue}
                        </Typography>
                    </StyledWrapper>
                ))}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default DisplayPieChart;
